const consulta_de_transporte_escolar_por_turma = [
  {
    path: "/consulta-de-transporte-escolar-por-turma",
    redirect: "/consulta-de-transporte-escolar-por-turma",
    meta: {
      breadCrumb: "Gestão - Informação Complementar do Aluno",
    },
    children: [
      {
        path: "/consulta-de-transporte-escolar-por-turma",
        name: "consulta_de_transporte_escolar_por_turma",
        component: () =>
          import(
            "@/views/ConsultaDeTransporteEscolarPorTurma/ConsultaDeTransporteEscolarPorTurma.vue"
          ),
      },
      {
        path: "/consulta-de-transporte-escolar-por-turma/:id",
        name: "consulta_de_transporte_escolar_por_turma_visualizar",
        component: () =>
          import(
            "@/views/ConsultaDeTransporteEscolarPorTurma/ConsultaDeTransporteEscolarPorTurmaVisualizar.vue"
          ),
      },
    ],
  },
];

export { consulta_de_transporte_escolar_por_turma };
